
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { projectSecretPlaceHolderByName } from '@shared/index';
import { ProjectSecretService } from '../../services/project-secret.service';
import { RouteShareService } from '../../services/route-share.service';

@Component({
  selector: 'app-secret-placeholder-list',
  imports: [RouterLink],
  templateUrl: './secret-placeholder-list.component.html',
  styleUrl: './secret-placeholder-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SecretPlaceholderListComponent {

  constructor(
    public rss: RouteShareService,
    public secretService: ProjectSecretService) {

  }

  public projectSecretPlaceHolderByName(name: string) {
    return projectSecretPlaceHolderByName(name);
  }

}
